






















































































































































































































import Vue from 'vue'
import fb from '../../firebase'
import LeftSidebarLayout from '@/components/LeftSidebarLayout'
import { Checkbox, Table, TableColumn } from 'element-ui'
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'
import SubscribeBilling from '@/mixins/SubscribeBilling'
import './Billing.scss'
import { KeyDict } from '@/types'
import { MonthBilling, BillingSummary, BillingCast } from '@/types/billing'
import CastSupportBadge from '@/components/CastSupportBadge/CastSupportBadge.vue'
import CastEnvBadge from '@/components/CastEnvBadge/CastEnvBadge.vue'
import { UserProfile } from '@/types/users'
import { Stream } from '@/types/streams'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'


export default Vue.extend({
  name: 'Billing',
  mixins: [ SubscribeBilling ],
  computed: {
    canReadReports (): boolean {
      return this.$can(AbilityAction.Read, AbilitySubject.Report)
    },
    canEditReports (): boolean {
      const can = this.$can(AbilityAction.Edit, AbilitySubject.Report)
      return can
    },
    canDoOps (): boolean {
      return this.$can(AbilityAction.Do, AbilitySubject.Ops)
    },
    summary (): BillingSummary {
      const r = this.$store.direct.state.team.billing.summary
      return r
    },
    billing (): KeyDict<KeyDict<MonthBilling>> {
      const r = this.summary.months
      return r
    },
    billingLoaded (): boolean {
      const r = this.$store.direct.state.team.billing.loaded
      return r
    },
    lastCalculated (): string {
      const last_update = this.summary.last_update
      let r = 'never'
      if (last_update !== undefined){
        const lastTimestamp = last_update.timestamp
        const date = lastTimestamp.toDate()
        r = this.dateToString(date)
      }
      return r
    },
    teamMembers (): UserProfile[] {
      return this.$store.direct.state.team.currentTeam
    },
    teamstream (): KeyDict<Stream> {
      return this.$store.direct.state.team.streams
    },
    eventIds (): string[] {
     let lastEventId = ''
      const ids: string[] = []
      let yearKeys = Object.keys(this.billingDetails)
      yearKeys = yearKeys.sort()
      yearKeys = yearKeys.reverse()
      for (const year of yearKeys){
        const yearDict = this.billingDetails[year]
        let monthKeys = Object.keys(yearDict)
        monthKeys = monthKeys.sort()
        monthKeys = monthKeys.reverse()
        for(const month of monthKeys){
          const billingCasts = yearDict[month]
          for(const bc of billingCasts){
            const eventId = bc.event_id
            if (eventId !== lastEventId) {
              ids.push(eventId)
              lastEventId = eventId
            }
          }
        }
      }
      return ids
    }
  },
  data: () => ({
    detailsLoading: {} as KeyDict<KeyDict<boolean>>,
    billingDetailsVisible: {} as KeyDict<KeyDict<boolean>>,
    billingDetails: {} as KeyDict<KeyDict<BillingCast[]>>,
    calculating: false,
    resyncing: false,
    resyncingAll: false,
  }),
  watch: {
    lastCalculated () {
      this.calculating = false
    },
    summary () {
      if(this.summary.force_resync == false){
        this.resyncing = false
        this.resyncingAll = false // TODO: this not really correct
      }
    }
  },
  methods: {
    monthKey (year: string, month:string): string {
      const monthId = 'month_' + year + month
      return monthId
    },
    safeGetDict<T> (dict: KeyDict<KeyDict<T>>, key:string) : KeyDict<T> {
      if(!(key in dict)){
        this.$set(dict, key, {})
      }
      return dict[key]
    },
    detailsHaveLoaded (year:string, month:string): boolean {
      const yearDetailsLoading = this.safeGetDict(this.detailsLoading, year)
      const loading = yearDetailsLoading[month] ?? true
      const r : boolean = ! loading
      return r
    },
    monthCanBeResynced (year: string, month: string): boolean {
      const today = new Date()
      const todayY = '' + today.getFullYear()
      const todayM = this.addLeadingZeros(today.getMonth() + 1) // start at 0...
      let result = false
      if (year == todayY && month == todayM){
        result = true
      }
      if(today.getMonth() == 0){
        const lastMonthY = '' + (today.getFullYear() -1)
        const lastMonthM = '12'
        if (year == lastMonthY && month == lastMonthM){
          result = true
        }
      } else{
        const lastMonthY = '' + today.getFullYear()
        const lastMonthM = this.addLeadingZeros(today.getMonth())
        if(year == lastMonthY && month == lastMonthM){
          result = true
        }
      }
      return result
    },
    recalculate () {
      this.$store.direct.dispatch.team.recalculateBilling()
      this.calculating = true
    },
    resync () {
      this.$store.direct.dispatch.team.resyncBilling()
      this.resyncing = true
    },
    resyncAll () {
      this.$store.direct.dispatch.team.resyncBillingAll()
      this.resyncingAll = true
    },
    production (monthBilling: MonthBilling) : [string, number][] {
      // property might be absent if calculation was done with previous version
      const productionDuration = monthBilling.production_duration ?? []
      const asArray : [string,number][] = []
      // fiddling to get a stable sort order from our dict
      for (const level in productionDuration) {
         const n = productionDuration[level]
         asArray.push([level, n])
      }
      const sortOrder = {
        'platinum': 0,
        'gold': 1,
        'silver': 2,
        'lite': 3
      }
      const ord = (e) =>{ return sortOrder[e[0]] }
      asArray.sort((e1,e2) => (ord(e1) - ord(e2)))
      return asArray
    },
    freeLeft (monthBilling: MonthBilling) : number {
      const free = monthBilling.free_duration ?? 0
      const test = monthBilling.test_duration ?? 0
      return free - test
    },
    monthToString (index: number): string {
      const month: string[] = []
      month[0] = 'January'
      month[1] = 'February'
      month[2] = 'March'
      month[3] = 'April'
      month[4] = 'May'
      month[5] = 'June'
      month[6] = 'July'
      month[7] = 'August'
      month[8] = 'September'
      month[9] = 'October'
      month[10] = 'November'
      month[11] = 'December'
      return month[index - 1]
    },
    dateToString (d : Date) : string{
      const monthNames = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      const datestring = this.addLeadingZeros(d.getDate()) + ' ' + monthNames[d.getMonth()] + ' ' +
                      d.getFullYear() + ' - ' + this.addLeadingZeros(d.getHours()) + ':' +
                      this.addLeadingZeros(d.getMinutes())
      return datestring
    },
    getDateString (timestamp: number): string {
      const date = new Date(timestamp * 1000)
      return this.dateToString(date)
    },
    toHoursFloor (minutes) {
      return Math.floor(minutes / 60.0)
    },
    addLeadingZeros (n) {
      let s = '' + n
      if (s.length < 2) {
        s = '0' + s
      }
      return s
    },

    getCasts (year:string, month:string) {
      this.loadCasts(year, month)
    },
    async loadCasts (year: string, month: string) : Promise<void> {
      const monthId = this.monthKey(year,month)
      const yearDict = this.safeGetDict(this.detailsLoading, year)
      yearDict[month] = true

      const teamId = this.$store.direct.state.team.activeTeam
      try {
        const casts : BillingCast[] = []
        const castDocs = await fb.db.collection('billing_details')
          .doc(teamId)
          .collection(monthId)
          .orderBy('start_time', 'desc')
          .get()

        castDocs.forEach(doc => {
          const data = doc.data()
          const billingCast = { ...data, id:doc.id } as BillingCast
          if (billingCast.name !== billingCast.event_name && billingCast.event_name !== '') {
            // TODO: Remove again once always cast==event
            billingCast.name = `${billingCast.name} [${billingCast.event_name}]`
          }
          casts.push(billingCast)
        })
        const yearDetailsB = this.safeGetDict(this.billingDetails, year)
        yearDetailsB[month] = casts
        const yearDetailsLoading = this.safeGetDict(this.detailsLoading, year)
        yearDetailsLoading[month] = false
        this.detailsLoading[year] = yearDetailsLoading
        this.$forceUpdate() // sorry. can't get rid of this one...
      } catch(error) {
        console.log(error)
      }

    },
    castsConvertedForCsv (casts) {
      const converted_casts: any[] = []
      let n_casts = 0
      casts.forEach(cast => {
        const converted_cast = JSON.parse(JSON.stringify(cast))
        let endTime = cast.end_time.seconds
        if (endTime < cast.start_time.seconds) {
          endTime = cast.start_time.seconds
        }
        converted_cast.quality = this.getQuality(cast.quality)
        converted_cast.resolution = this.getResolution(cast.quality)
        converted_cast.start_time = this.getDateString(cast.start_time.seconds).split('-')[1].trim()
        converted_cast.end_time = this.getDateString(endTime).split('-')[1].trim()
        converted_cast.start_date = this.getDateString(cast.start_time.seconds).split('-')[0].trim()
        converted_cast.end_date = this.getDateString(endTime).split('-')[0].trim()
        converted_cast.outputs = this.parseOutputs(cast.custom_rtmp_destinations)
        converted_cast.casters = this.parseCasters(cast.invited_casters)
        delete converted_cast.custom_rtmp_destinations
        delete converted_cast.event_id
        delete converted_cast.invited_casters
        converted_casts.push(converted_cast)

        n_casts = n_casts + 1
      })
      console.log('# casts', n_casts)
      return converted_casts
    },
    getQuality (quality) {
      if (!quality) {
        return 'unknown'
      }
      const decompose = quality.split('p')
      if (decompose.length < 2) {
        return 'unknown'
      }
      return parseInt(decompose[1])
    },
    parseOutputs (custom_rtmp_destinations) {
      let outputs = ''
      if (!custom_rtmp_destinations) {
        return ''
      }
      Object.keys(custom_rtmp_destinations).forEach(key => {
        if (this.teamstream[key]) {
          outputs += `${this.teamstream[key].name}`
        } else {
          outputs += `${custom_rtmp_destinations[key].url}`
        }
        outputs += ' '
      })
      return outputs.trim()
    },
    parseCasters (invited_casters) {
      let casters = ''
      if (!invited_casters) {
        return ''
      }
      Object.keys(invited_casters).forEach(key => {
        const caster = this.teamMembers.find(member => member.id === key)
        if (caster) {
          casters += `${caster.first_name} ${caster.last_name}`
        }
        casters += ' '
      })
      return casters.trim()
    },
    getResolution (quality) {
      if (!quality) {
        return 'unknown'
      }
      const decompose = quality.split('p')
      if (decompose.length < 2) {
        return 'unknown'
      }
      return parseInt(decompose[0]) + 'p'
    },
    exportToCsv (year:string, month:string) {
      const casts = this.castsConvertedForCsv(this.billingDetails[year][month])
      const name = this.monthToString(parseInt(month)) + '-' + year
      const preamble = 'data:application/octetstream;base64,'
      const KEYS = ['name',
        'start_date','start_time',
        'end_date', 'end_time',
        'duration', 'supportLevel', 'event_name', 'watermark', // TODO: Remove 'event_name' again once always cast==event
        'large_machine', 'crosscontinent', 'quality', 'resolution',
        'outputs', 'casters', 'is_copy', 'record_isos', 'deleted'
        ]
      if (this.$can(AbilityAction.Do, AbilitySubject.Ops)){ // handy for tracing
        KEYS.push('id')
      }
      const lines :string[] = []
      lines.push(KEYS.join(';'))
      const monthBilling = this.summary.months[year][month]
      function maybe_csv_escape (s: string) : string {
        const t = s.replace(/"/g, '""') // repeat double quotes
        if (t.indexOf(';') > -1){
          return '"' + t + '"'; // wrap
        }
        return t
      }
      function csv_value (cast: BillingCast, key:string) : string {
        const value = String(cast[key]) // this maps undefined to 'undefined' aso ...
        return maybe_csv_escape(value)
      }
      for (const cast of casts){
        const items = KEYS.map(key => csv_value(cast, key))
        const line = items.join(';')
        lines.push(line)
        const cast_id : string = cast.id
        if (monthBilling.cast_ids[cast_id] === undefined){
          console.log('spurious cast.id=', cast_id)
        }
      }
      const csvContent = lines
        .join('\n')
        .replace(/(^\[)|(\]$)/gm, '')

      const data = preamble + btoa(unescape(encodeURIComponent(csvContent)))
      const link = document.createElement('a')
      link.setAttribute('href', data)
      link.setAttribute('download', name + '.csv')
      link.click()
    },
    detailsVisible (year, month) {
      const yearDetailsVisible = this.safeGetDict(this.billingDetailsVisible, year)
      const r = yearDetailsVisible[month] ?? false
      return r
    },
    tableRowClassName ({ row }) {
      let name = 'even-row'
      try {
        name = this.eventIds.indexOf(row.event_id) % 2 === 0 ? 'odd-row' : 'even-row'
      }catch(error){
        console.log('problem with even/odd:', error)
      }
      return name
    },
    setDetailsVisible (year:string, month:string, visible:boolean) {
      const yearDetailsVisible = this.safeGetDict(this.billingDetailsVisible, year)
      if(yearDetailsVisible[month] === undefined) {
        this.getCasts(year,month)
      }
      yearDetailsVisible[month] = visible
      this.$forceUpdate()
    },
    updateBillingIgnore (event:boolean, billingCast: BillingCast)  {
      const teamId = this.$store.direct.state.team.activeTeam
      const startDate = billingCast.start_time.toDate()
      const month = this.addLeadingZeros(startDate.getMonth() + 1)
      const year = '' + startDate.getFullYear()
      const monthKey = this.monthKey(year, month)
      const params = {
        castId : billingCast.id,
        billingIgnore: event,
        teamId: teamId,
        monthKey: monthKey
      }
      this.$store.direct.dispatch.events.updateCastAndBillingCast(params)
    }
  },
  components: {
    LeftSidebarLayout,
    'clip-loader': ClipLoader,
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-checkbox': Checkbox,
    CastSupportBadge,
    CastEnvBadge
  }
})
